import styled from 'styled-components';

export const SolutionsDetail = styled.div`
  .white-btn {
    padding: 9px 0;
    margin-left: 10px;
  }

  .brief-btn {
    padding: 9px 0;
    margin-left: 10px;

    @media only screen and (max-width: 480px) {
      margin-left: 0;
    }
  }

  .partner-hero-content p {
    margin-bottom: 46px;
  }
  .inner-hero-area h1 {
    margin-bottom: 0;
  }

  .grey-bg {
    background-color: #fafafa;
  }

  .principle-main {
    padding: 130px 0 0;
    position: relative;
    background-color: #181726;

    @media only screen and (max-width: 767px) {
      padding-bottom: 130px;
    }
  }

  .featured-partner-block {
    padding: 100px 0;
    max-width: 800px;
    margin: 0 auto;

    @media only screen and (max-width: 979px) {
      padding: 50px 0;
    }

    .pink-btn {
      margin-top: 60px;
    }
  }
  .featured-sec-2 {
    background-color: #fafafa;
    padding: 100px 0 50px;
  }
  .faetured-2-logo {
    padding-bottom: 35px;
  }
  .featured-sec-2-txt {
    padding-bottom: 70px;
  }
  .featured-sec-2-img {
    text-align: right;
  }
  .why-partner-icon {
    display: block;
    margin-bottom: 20px;
  }

  .why-partner-single {
    margin-bottom: 45px;

    h3 {
      color: #0a090b;
      font-family: 'Be Vietnam Pro', sans-serif;
      font-size: 22px;
      letter-spacing: -0.24px;
      margin: 0;
    }

    p {
      color: #0a090b;
      font-size: 16px;
      letter-spacing: -0.12px;
      line-height: 1.5;
      max-width: 200px;
      margin-top: 10px;
    }
  }

  .why-partner-main {
    margin: 100px 0 0;
  }
  .why-partner-block .big-heading {
    margin-bottom: 55px;
  }
  .why-partner-main {
    margin: 100px 0 0;
    padding-bottom: 50px;
    position: relative;

    h2 {
      font-size: 48px;
      line-height: 1.1875;

      @media only screen and (max-width: 767px) {
        font-size: 36px;
      }
    }
  }

  .partner-quote-area {
    padding-bottom: 45px;
  }
  .companies-main h2 {
    color: #0a090b;
    font-size: 33px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 46px;
    text-align: center;
  }

  .single-company {
    width: 160px;
    padding: 30px 0;

    text-align: center;
  }
  .companies-block {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
  }

  .companies-main {
    padding: 150px 0;
  }
  .industries-block {
    padding-bottom: 0;
  }

  @media (max-width: 1024px) {
    .featured-partner-txt {
      margin-bottom: 55px;
    }
    .featured-partner-block .row {
      align-items: flex-end;
    }
  }

  @media (max-width: 767px) {
    .featured-partner-main .small-heading {
      font-size: 38px;
      line-height: 45px;
    }
    .featured-partner-block {
      padding: 50px 0;
      text-align: left;
    }
    .featured-partner-img .pink-btn {
      position: absolute;
      bottom: 40px;
      left: 0;
      right: 0;
    }
    .featured-partner-img {
      position: relative;
    }
    .featured-sec-2 {
      background-color: #fafafa;
      padding: 60px 0 50px;
    }
    .featured-sec-2-txt,
    .faetured-2-logo {
      text-align: center;
    }
    .featured-sec-2-txt {
      padding-bottom: 10px;
    }
    .featured-sec-2-btn-img {
      text-align: center;
    }
    .featured-sec-2-btn-img .pink-btn {
      display: block;
      margin-top: 35px;
    }
    .partner-quote-area {
      padding-bottom: 0;
    }
    .white-btn {
      margin: 15px 0 0;
      display: block;
    }

    .featured-partner-main {
      padding: 20px 0 0;
    }
    .why-partner-main::before {
      display: none;
    }
    .why-partner-single {
      margin-bottom: 25px;
      text-align: center;
    }
    .why-partner-single h3 {
      font-size: 20px;
    }
    .companies-main {
      padding: 0 0;
    }

    .single-company img {
      width: 100px;
    }
    .single-company {
      width: 46%;
      padding: 0;
      text-align: center;
      border: 1px solid #eee;
      height: 90px;
      margin: 7px 3px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
